import { useContext, useEffect, useState } from 'react';
import { PolicyList, Typography, StatusBox } from 'iglooform';
import { Spin } from 'antd';
import { useIntl } from 'react-intl';
import {
  RoleMessages,
  UserStatusMessages,
  UserStatusTypes,
} from '@/utils/role';
import Context from '@/utils/context';
import { images } from '@/assets/images';
import styles from './index.less';
import throttle from 'lodash/throttle';
import { getAgencyInfo } from '../service';

const BusinessManagementUpline = () => {
  const { formatMessage } = useIntl();
  const { isPc } = useContext(Context);
  const [userInfo, setUserInfo] = useState<UserInfo>();
  const [loading, setLoading] = useState<boolean>(false);

  const handleGetAgencyInfo = throttle(
    async (): Promise<void> => {
      getAgencyInfo()
        .then((res) => {
          if (res) {
            setUserInfo(res.userInfo);
          }
        })
        .finally(() => setLoading(false));
    },
    1000,
    { leading: true, trailing: false },
  );

  useEffect(() => {
    handleGetAgencyInfo();
  }, []);

  const { name, email, phone_number, status, role } = userInfo?.up_line || {};

  const statusPropsType = status ? UserStatusTypes[status] : undefined;
  const statusPropsChildren = status
    ? formatMessage(UserStatusMessages[status])
    : '';

  const userTitle = role ? formatMessage(RoleMessages[role]) : '-';

  const dataList = [
    {
      emptyText: formatMessage({ id: 'There is currently no data.' }),
      insurerName: name,
      statusProps: {
        type: statusPropsType,
        children: statusPropsChildren,
      },
      defaultItems: [
        {
          title: formatMessage({ id: 'Title' }),
          info: userTitle,
          span: 8,
        },
        {
          title: formatMessage({ id: 'Email' }),
          info: email || '-',
          span: 8,
        },
        {
          title: formatMessage({ id: 'Phone' }),
          info: phone_number ? `0${phone_number}` : '-',
          span: 8,
        },
      ],
    },
  ];

  const H5UplineCard = () => (
    <div className={styles.h5UplineCard}>
      <div className={styles.name}>
        <Typography level="h4">{name}</Typography>
        <StatusBox type={statusPropsType}>{statusPropsChildren}</StatusBox>
      </div>
      <div className={styles.line}>
        <img src={images.job_title_icon} alt="" />
        <div>{userTitle}</div>
      </div>
      <div className={styles.line}>
        <img src={images.small_email_icon} alt="" />
        <div>{email}</div>
      </div>
      <div className={styles.line}>
        <img src={images.phone_icon} alt="" />
        <a
          style={{ color: '#5858FF' }}
          href={`tel:0${phone_number}`}
        >{`0${phone_number}`}</a>
      </div>
    </div>
  );

  const renderContent = isPc ? (
    <PolicyList className={styles.upline} dataList={dataList as any} />
  ) : (
    <H5UplineCard />
  );

  return <Spin spinning={loading}>{renderContent}</Spin>;
};

export default BusinessManagementUpline;
